import React, { useContext, useEffect, useState } from 'react'
import { startService, stopService } from '../../services/serviceWatchService';
import { ThemeContext } from '../../layout/BaseLayout';

const ServiceWatchTr = (props) => {

    const [healthStatus, setHealthStatus] = useState([]);
    const [disableStartBtn, setDisableStartBtn] = useState(false);
    const [disableStopBtn, setDisableStopBtn] = useState(false);
    let toast = useContext(ThemeContext)

    const checkApiHealth = async (endpoint, port) => {
        if (!!endpoint && !!port && (!!props.selectDomain || props?.selectedLicence)) {
            const url = `https://${endpoint}.${props.selectDomain}:${port}`;
            try {
                const response = await fetch(url, { method: 'GET' });
                return response.ok ? '✔️ API is running' : '❌ API is down';
            } catch (error) {
                console.error('Error checking API health:', error);
                return '❌ API is not reachable';
            }
        }
    };

    const checkAllApis = async () => {
        if (!!props?.item) {
            let status = ''
            if (props?.item.ServiceType === 'IIS' && props?.selectedLicence && props?.item.Endpoint) {
                status = await checkApiHealth(props?.item.Endpoint, props?.item.Port);
            }

            setHealthStatus((prev) => [
                ...prev.filter((ser) => ser.id !== props?.item.ServiceName),
                { id: props?.item.ServiceName, status },
            ]);
        }
    };

    useEffect(() => {
        if (!!props.selectDomain) {
            checkAllApis();
        }
    }, [props.selectDomain, props.selectedLicence])

    const getStatusByServiceName = (serviceName) => {
        const service = healthStatus.find((status) => status.id === serviceName);
        return service ? service.status : 'Loading...';
    };

    const startServiceFn = (item) => {
        setDisableStartBtn(true);
        startService(item, props?.selectedLicence).then((res) => {
            if (res.isSuccess) {
                props.regetservices();
                checkAllApis();
                toast.success(!!res?.data?.message ? res?.data?.message : "Success")
            } else {
                toast.error(res?.exception?.message)
            }
            setDisableStartBtn(false);
        }).catch(err => {
            setDisableStartBtn(false);
        })
    }

    const stopServiceFn = (item) => {
        setDisableStopBtn(true);
        stopService(item, props?.selectedLicence).then((res) => {
            if (res.isSuccess) {
                props.regetservices();
                checkAllApis();
                toast.success(!!res?.data?.message ? res?.data?.message : "Success")
            } else {
                toast.error(res?.exception?.message)
            }
            setDisableStopBtn(false);
        }).catch(err => {
            setDisableStopBtn(false);
        })
    }

    return (
        <tr className={`${!props?.item?.status ? "service-status-bg-yellow" : (props?.item?.status !== "Running" ? "service-status-bg" : "")}`}>
            <td className=''>{props?.index}</td>
            <td className=''>{props?.item?.ServiceType}</td>
            <td className=''>{props?.item?.ServiceName}</td>
            <td className=''>{props?.item.ServiceType === "IIS" && props?.selectedLicence ? (
                <a
                    href={`https://${props?.item?.Endpoint ? props?.item.Endpoint : ""}.${props.selectDomain}:${props?.item?.Port ? props?.item.Port : ""}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {`https://${props?.item?.Endpoint ? props?.item.Endpoint : ""}.${props.selectDomain}:${props?.item?.Port ? props?.item.Port : ""}`}
                </a>
            ) : (
                ""
            )}
            </td>
            <td>{props?.item.ServiceType === "IIS" && getStatusByServiceName(props?.item.ServiceName)}</td>
            <td className={`d-flex`}>
                <button className="btn btn-primary bg-white text-black mb-0 mr-2" disabled={disableStartBtn || props?.item?.status === "Running"} onClick={() => startServiceFn(props?.item?.name)}>
                    <i id="restartServiceRefresh" className={`fa fa-play font-size-14 remove_arrow_summary mr-1 ${!disableStartBtn ? "text-danger" : "gray-text"}`} ></i>
                    <span>Start</span>
                </button>
                <button className="align-center bg-white btn btn-primary d-flex justify-content-center mb-0 text-black mr-2" disabled={disableStopBtn || props?.item?.status !== "Running" || !(!!props?.item?.status)} onClick={() => stopServiceFn(props?.item?.name)}>
                    <i id="restartServiceRefresh" className={`fa fa-stop font-size-14 remove_arrow_summary mr-1 ${!disableStopBtn ? "text-danger" : "gray-text"}`} ></i>
                    <span>Stop</span>
                </button>
            </td>
        </tr>
    )
}

export default ServiceWatchTr